// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".spinner[data-v-cc3e8e04]{opacity:1;display:inline-block;vertical-align:middle;border:4px solid #f3f3f3;border-top:4px solid #3498db;border-radius:50%;width:18px;height:18px;animation:spin-data-v-cc3e8e04 1s linear infinite;margin:0 0 0 10px;padding:0;transition:all .2s ease}.hidden>.spinner[data-v-cc3e8e04]{max-width:0!important;max-height:0!important;border-width:0!important;margin:0;opacity:0}@keyframes spin-data-v-cc3e8e04{0%{transform:rotate(0)}100%{transform:rotate(360deg)}}", ""]);
// Exports
module.exports = exports;
